import Section from "../components/Section";

const Home = () => {
    return (
        <div>
            
            <Section />
        </div>
    )
}

export default Home;
